import React from "react";
import PropTypes from "prop-types";
import Form from "../../../components/adm/form/formForm";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const FormFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

FormFormPage.propTypes = {};

export default FormFormPage;
